import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./PhotographyCategories.css";

function PhotographyCategories() {
  const { t } = useTranslation();

  const categories = [
    {
      number: "01",
      nameKey: "photography.categories.weddings.name",
      textKey: "photography.categories.weddings.text",
      firebaseCategory: "Weddings",
      className: "weddings-category",
      image:
        "https://i.postimg.cc/GpNhZDzy/Whats-App-Image-2026-08-18-at-9-55-44-PM.jpg",
    },

    {
      number: "02",
      nameKey: "photography.categories.islamicWeddings.name",
      textKey: "photography.categories.islamicWeddings.text",
      firebaseCategory: "Islamic Weddings",
      className: "islamic-weddings-category",
      image:
        "https://i.postimg.cc/jjWRQ5KC/Whats-App-Image-2026-08-18-at-9-55-53-PM.jpg",
    },

    {
      number: "03",
      nameKey: "photography.categories.engagements.name",
      textKey: "photography.categories.engagements.text",
      firebaseCategory: "Engagements",
      className: "engagements-category",
      image:
        "https://i.postimg.cc/Bv1GPVcb/Whats-App-Image-2026-08-18-at-9-55-47-PM.jpg",
    },

    {
      number: "04",
      nameKey: "photography.categories.bridalSessions.name",
      textKey: "photography.categories.bridalSessions.text",
      firebaseCategory: "Bridal Sessions",
      className: "bridal-category",
      image:
        "https://i.postimg.cc/gjg7TVHr/Whats-App-Image-2026-08-18-at-9-55-42-PM.jpg",
    },

    {
      number: "05",
      nameKey: "photography.categories.womenEvents.name",
      textKey: "photography.categories.womenEvents.text",
      firebaseCategory: "Women Events",
      className: "women-category",
      image:
        "https://i.postimg.cc/T1Nk9RTT/Whats-App-Image-2026-08-18-at-9-55-49-PM.jpg",
    },

    {
      number: "06",
      nameKey: "photography.categories.familyFriends.name",
      textKey: "photography.categories.familyFriends.text",
      firebaseCategory: "Family & Friends",
      className: "mixed-category",
      image:
        "https://i.postimg.cc/NGn7pC1x/Whats-App-Image-2026-08-18-at-9-55-54-PM.jpg",
    },
  ];

  return (
    <section
      className="photography-categories"
      id="photography-categories"
    >
      {/* =========================
          HEADING
      ========================= */}

      <div className="photography-categories-heading">
        <span className="photography-label">
          {t("photography.label")}
        </span>

        <h2>
          {t("photography.title1")}
          <br />
          <span>{t("photography.title2")}</span>
        </h2>

        <div className="photography-divider">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>
      </div>

      {/* =========================
          CATEGORIES
      ========================= */}

      <div className="photography-circles">
        {categories.map((category) => (
          <Link
            key={category.firebaseCategory}
            to={`/gallery/Photography/${encodeURIComponent(
              category.firebaseCategory
            )}`}
            className={`photography-category-circle ${category.className}`}
            style={{
              backgroundImage: `url("${category.image}")`,
            }}
          >
            {/* Overlay */}

            <div className="photography-circle-overlay"></div>

            {/* Content */}

            <div className="photography-circle-content">
              <span className="photography-number">
                {category.number}
              </span>

              <h3>{t(category.nameKey)}</h3>

              <div className="photography-small-line">
                <span></span>
                <i>✦</i>
                <span></span>
              </div>

              <p>{t(category.textKey)}</p>

              <div className="photography-arrow">↗</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default PhotographyCategories;